import React from 'react';
import { TruckTrendChart } from '../Charts/TrucksTrendChart';

const TrucksTrend = ({ data = [] }) => (
  <div className="white-wraper extra-mt">
    <h2 className="add-margin">Required v/s Assigned Truck Trend ({data?.[0]?.year ?? new Date().getFullYear()})</h2>

    <div className="chart-data">
      <ul>
        <li><div className="chart-dot cd8"></div><p>Required</p></li>
        <li><div className="chart-dot cd9"></div><p>Assigned</p></li>
      </ul>
    </div>

    <div className="chart-canvas2 hstruck-trend">
      {data.length > 0 ? (
        <TruckTrendChart data={data} />
      ) : (
        <div className="text-center text-secondary" style={{ display:'flex', width:'100%', alignItems:'center', justifyContent:'center' }}>No data available</div>
      )}
    </div>
  </div>
);

export default TrucksTrend;
